<template>
  <div class="property-index-container">
    <div class="vc-index-nav">
      <span><i class="el-icon-s-home margin-right-sm"></i>{{ $t('propertyIndex.home') }}</span>
      <span class="margin-left-sm margin-right-sm">/</span>
      <span>{{ $t('propertyIndex.dashboard') }}</span>
    </div>

    <el-row class="vc-index-1" :gutter="20">
      <el-col :span="12">
        <index-revenue ref="indexRevenue" />
      </el-col>
      <el-col :span="12">
        <index-cost ref="indexCost" />
      </el-col>
    </el-row>
    <el-row class="vc-index-1" :gutter="20">
      <el-col :span="12">
        <index-park ref="indexPark" />
      </el-col>
      <el-col :span="12">
        <index-room-style ref="indexRoomStyle" />
      </el-col>
    </el-row>
<!--    <el-row class="vc-index-1" :gutter="20">-->
<!--      <el-col :span="12">-->
<!--        <index-community ref="indexCommunity" />-->
<!--      </el-col>-->
<!--      <el-col :span="12">-->
<!--        <index-notice ref="indexNotice" />-->
<!--      </el-col>-->
<!--    </el-row>-->

    <el-row class="vc-index-1" :gutter="20">
      <el-col :span="12">
        <index-repair-complaint ref="indexRepairComplaint" />
      </el-col>
      <el-col :span="6">
        <index-owner-room ref="indexOwnerRoom" />
      </el-col>
      <el-col :span="6">
        <index-notice ref="indexNotice" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import IndexCommunity from '@/components/index/indexCommunity'
 import IndexNotice from '@/components/index/indexNotice'
import IndexRepairComplaint from '@/components/index/indexRepairComplaint'
import IndexOwnerRoom from '@/components/index/indexOwnerRoom'


import indexRevenue from '@/components/index/indexRevenue.vue'
import indexCost from '@/components/index/indexCost.vue'
import indexPark from '@/components/index/indexPark.vue'
import indexRoomStyle from '@/components/index/indexRoomStyle'
export default {
  name: 'PropertyIndexList',
  components: {
    // IndexCommunity,
     IndexNotice,
    IndexRepairComplaint,
    IndexOwnerRoom,
    indexRevenue,
    indexCost,
    indexPark,
    indexRoomStyle
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      // this.$refs.indexCommunity._loadPropertyIndexAssets()
      this.$refs.indexRevenue._loadPropertyIndexAssets()//1
      this.$refs.indexCost._loadPropertyIndexAssets()//2
      this.$refs.indexPark._loadPropertyIndexAssets()//3
      this.$refs.indexRoomStyle._loadPropertyIndexAssets()//4
      this.$refs.indexRepairComplaint.initData()//5
      this.$refs.indexOwnerRoom._loadIndexOwnerRegisterData()//6
      this.$refs.indexNotice._loadPropertyIndexNotices()//7
    }
  }
}
</script>

<style lang="scss" scoped>
.property-index-container {
  background: rgba(247, 248, 255, 1);
  padding: 0 20px; // 添加左右内边距

  .vc-index-nav {
    padding: 10px;
    font-size: 16px;
    text-align: left;
  }

  .margin-right-sm {
    margin-right: 5px;
  }

  .margin-left-sm {
    margin-left: 5px;
  }

  .margin-top-lg {
    margin-top: 15px;
  }

  .margin-bottom {
    margin-bottom: 20px;
  }

  .vc-index-1 {
    margin-bottom: 20px;
    // 修复 Element UI 栅格系统的 gutter 问题


    .index-1-left,
    .index-1-right {
      height: 100%;
    }
  }
}
</style>
